import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
export function AIAssistantPage() {
  return <div className="pt-32 pb-20" data-id="element-1252">
      {/* Hero */}
      <section className="max-w-4xl mx-auto px-6 text-center mb-24" data-id="element-1253">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-8" data-id="element-1254">
          <Sparkles className="w-8 h-8 text-primary" data-id="element-1255" />
        </motion.div>
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-5xl md:text-6xl font-bold tracking-tight mb-6 leading-tight" data-id="element-1256">
          Operate Booker in plain language.
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-xl text-textMuted mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-1257">
          Ask Booker to plan routes, summarize offers, draft outreach, check
          lineup conflicts, or prepare contracts — all on top of the same
          structured workflow engine.
        </motion.p>
      </section>

      {/* Prompts Grid */}
      <section className="max-w-5xl mx-auto px-6" data-id="element-1258">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-1259">
          {['Plan us a June route from Michigan to New England.', 'Draft outreach for the best 25 folk venues on this route.', 'Check whether our lineup can actually cover these dates.', 'Summarize every offer below our minimum fee.'].map((prompt, i) => <div key={i} className="bg-surface border border-border rounded-xl p-6 flex items-center gap-4 group hover:border-primary/50 transition-colors cursor-pointer" data-id="element-1260">
              <div className="w-8 h-8 rounded-full bg-background border border-border flex items-center justify-center shrink-0" data-id="element-1261">
                <Sparkles className="w-4 h-4 text-textMuted group-hover:text-primary transition-colors" data-id="element-1262" />
              </div>
              <p className="text-lg font-medium" data-id="element-1263">"{prompt}"</p>
              <ArrowRight className="w-5 h-5 text-textMuted ml-auto opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1264" />
            </div>)}
        </div>
      </section>
    </div>;
}